import Uiconstants from "../../lib/UIconstants";
import AutoSpinController from "../../controllers/action_buttons/AutoSpinController";
// import SpinBtnController from "../../controllers/action_buttons/SpinBtnController";
import FastPlayController from "../../controllers/action_buttons/FastPlayController";

import { COMPONENTS } from "../../lib/constants";
import SpinButtonController from "../../controllers/action_buttons/SpinButtonController";
// import { isDesktop } from "react-device-detect";

// let scale = isDesktop ? 1 : 0;

export const SpinButtons = {
  name: COMPONENTS.SPIN_BUTTONS,
  position: {
    x: 1410,
    y: 855 - 86,
  },
  controllers: [
    {
      Controller: AutoSpinController,
      name: Uiconstants.BTN_AUTO,
      config: {
        modal: Uiconstants.BTN_AUTO,
        item: COMPONENTS.AUTO_SPIN,
        infinity: "infinity_symbol",
        text: "BTN_NUMBER_OF_BETS",
      },
    },
    {
      Controller: FastPlayController,
      name: Uiconstants.BTN_FASTPLAY,
      config: {
        btn: Uiconstants.BTN_FASTPLAY,
      },
    },
    {
      Controller: SpinButtonController,
      name: "SpinBtnController",
      config: {
        item: "spin_stop",
      },
    },
  ],

  components: [
    {
      name: "holder",
      type: "Sprite",
      components: [
        {
          name: "spin_stop",
          type: "Sprite",
          position: { x: 234, y: 86 },
          components: [
            {
              name: Uiconstants.BTN_SPIN,
              type: "SpinButton",
              position: { x: 0, y: 0 },
              bg: "spin_btn",
              bg_icon: "spin_icon",
              fg_icon: "stop_icon",
              animation: {
                pattern: "pb$.png",
                start: 0,
                end: 23,
                speed: 0.5,
                loop: true,
              },
            },
          ],
        },
        {
          name: Uiconstants.BTN_FASTPLAY,
          type: "ToggleButtonNew",
          position: { x: 40, y: 48 + 86 },
          bg: "btn_small",
          icon: "fast_icon",
          animation: {
            pattern: "sparks$.png",
            start: 0,
            end: 24,
            speed: 0.5,
            loop: true,
          },
        },
        {
          name: Uiconstants.BTN_AUTO,
          type: "ToggleButtonNew",
          position: { x: 40, y: 42 },
          bg: "btn_small",
          icon: "auto_icon",
          iconActive: "auto_icon",
          animation: {
            pattern: "sparks$.png",
            start: 0,
            end: 24,
            speed: 0.5,
            loop: true,
          },
        },
      ],
    },
  ],
};
